import { render, staticRenderFns } from "./AdminUpdateTenderDocs_old.vue?vue&type=template&id=4408d0a4&scoped=true&"
import script from "./AdminUpdateTenderDocs_old.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateTenderDocs_old.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateTenderDocs_old.vue?vue&type=style&index=0&id=4408d0a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4408d0a4",
  null
  
)

export default component.exports